import { render, staticRenderFns } from "./inputRadioGroup.vue?vue&type=template&id=703b5ac0&scoped=true"
import script from "./inputRadioGroup.vue?vue&type=script&lang=js"
export * from "./inputRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./inputRadioGroup.vue?vue&type=style&index=0&id=703b5ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b5ac0",
  null
  
)

export default component.exports